import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SITE_DEFAULTS = {
  phone: "+91 80504 44041",
  whatsapp: "918050444041",
  email: "info@urbanveera.com",
  instagram: "",
  facebook: "",
  linkedin: "",
  youtube: "",
};

let cache = null;
let inflight = null;

const fetchSite = () => {
  if (!inflight) {
    inflight = axios
      .get(`${API}/site-settings`)
      .then((res) => {
        cache = { ...SITE_DEFAULTS, ...res.data };
        return cache;
      })
      .catch(() => SITE_DEFAULTS);
  }
  return inflight;
};

export const refreshSiteSettings = () => {
  cache = null;
  inflight = null;
};

export const useSiteSettings = () => {
  const [site, setSite] = useState(cache || SITE_DEFAULTS);
  useEffect(() => {
    if (cache) {
      setSite(cache);
      return;
    }
    let active = true;
    fetchSite().then((s) => {
      if (active) setSite(s);
    });
    return () => {
      active = false;
    };
  }, []);
  return site;
};
